import { Col, Row } from "antd";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { InputField, ReactSelectField } from "../../../../../atoms/FormElement";
import {
  getInputPlaceholderMessage,
  getMinMaxValidationRules,
  getSelectPlaceholderMessage,
  getValidationProps,
} from "../../../../../libs/form";

export const CompanyTenantDetailsFields = () => {
  const { configData } = useSelector((state: any) => state.newBooking);
  const { control, setValue, formState } = useFormContext();

  const { errors } = formState;

  const defaultProps = { control, setValue };

  return (
    <>
      <Row gutter={24}>
        <Col span={8}>
          <InputField
            fieldname="commercial.company.email"
            label="Email address"
            {...defaultProps}
            {...getValidationProps({ fieldName: "commercial.company.email", errors, isRequired: true })}
            iProps={{ placeholder: getInputPlaceholderMessage("email address") }}
          />
        </Col>
        <Col span={8}>
          <InputField
            fieldname="commercial.company.name"
            label="Company name"
            {...defaultProps}
            {...getValidationProps({ fieldName: "commercial.company.name", errors, isRequired: true })}
            iProps={{ placeholder: getInputPlaceholderMessage("company name") }}
          />
        </Col>
        <Col span={8}>
          <InputField
            fieldname="commercial.company.phone"
            label="Phone number"
            {...defaultProps}
            {...getValidationProps({
              fieldName: "commercial.company.phone",
              errors,
              isRequired: true,
              rules: getMinMaxValidationRules({ label: "Phone number", min: 9, max: 9 }),
            })}
            iProps={{ addonBefore: "+971", placeholder: "123456789" }}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={8}>
          <InputField
            isRequired
            fieldname="commercial.company.address"
            label="Office address"
            {...defaultProps}
            {...getValidationProps({ fieldName: "commercial.company.address", errors, isRequired: true })}
            iProps={{ placeholder: getInputPlaceholderMessage("office address") }}
          />
        </Col>
        <Col span={8}>
          <InputField
            fieldname="commercial.company.city"
            label="City"
            {...defaultProps}
            {...getValidationProps({ fieldName: "commercial.company.city", errors, isRequired: true })}
            iProps={{ placeholder: getInputPlaceholderMessage("city") }}
          />
        </Col>
        <Col span={8}>
          <ReactSelectField
            fieldname="commercial.company.country"
            label="Country"
            selectOption={configData.nationalityList}
            {...defaultProps}
            {...getValidationProps({ fieldName: "commercial.company.country", errors, isRequired: true })}
            iProps={{ placeholder: getSelectPlaceholderMessage("country") }}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={8}>
          <InputField
            fieldname="commercial.company.poBox"
            label="PO box"
            {...defaultProps}
            {...getValidationProps({ fieldName: "commercial.company.poBox", errors, isRequired: false })}
            iProps={{ placeholder: getInputPlaceholderMessage("po box") }}
          />
        </Col>
        <Col span={8}>
          <InputField
            isRequired
            fieldname="commercial.company.licenseNo"
            label="License no."
            {...defaultProps}
            {...getValidationProps({ fieldName: "commercial.company.licenseNo", errors, isRequired: true })}
            iProps={{ placeholder: getInputPlaceholderMessage("license no.") }}
          />
        </Col>
        <Col span={8}>
          <InputField
            fieldname="commercial.company.workPhone"
            label="Work phone"
            {...defaultProps}
            {...getValidationProps({
              fieldName: "commercial.company.workPhone",
              errors,
              isRequired: false,
              rules: {
                ...getMinMaxValidationRules({ label: "Work phone", min: 8, max: 20 }),
                validate: (value: string) => {
                  if (!value || value.trim() === "") {
                    return true; // Optional field, empty is valid
                  }
                  if (value.length < 8) {
                    return "Work phone must be at least 8 characters";
                  }
                  if (value.length > 20) {
                    return "Work phone must be at most 20 characters";
                  }
                  return true;
                },
              },
            })}
            iProps={{ placeholder: "12345678" }}
          />
        </Col>
      </Row>
    </>
  );
};
